import { motion } from "framer-motion";
import { Heart, Lightbulb } from "lucide-react";
import { useT } from "@/i18n";
import { BIZ_TEXT } from "@/components/business/products";

const COLORS = ["bg-yellow-200", "bg-sky-200", "bg-pink-200", "bg-lime-200", "bg-violet-200", "bg-orange-200"];

export default function NameResults({ result, onPick }) {
  const { lang } = useT();
  const tx = BIZ_TEXT[lang];
  return (
    <div className="mt-5">
      {result.tip && (
        <div className="bg-white/90 rounded-2xl p-4 flex gap-3 items-start shadow-md" data-testid="biz-tip">
          <Lightbulb className="w-6 h-6 text-yellow-500 shrink-0" />
          <p className="text-blue-950 font-semibold"><span className="font-bold">{tx.tip}:</span> {result.tip}</p>
        </div>
      )}
      <div className="mt-4 grid sm:grid-cols-2 gap-3">
        {result.names.map((n, i) => (
          <motion.div
            key={n.name + i}
            initial={{ opacity: 0, scale: 0.8, rotate: i % 2 ? 3 : -3 }}
            animate={{ opacity: 1, scale: 1, rotate: 0 }}
            transition={{ delay: i * 0.08, type: "spring", stiffness: 200 }}
            className={`${COLORS[i % COLORS.length]} rounded-2xl border-4 border-white p-4 shadow-md flex items-center justify-between gap-3`}
            data-testid={`biz-name-${i}`}
          >
            <div>
              <p className="font-fredoka text-xl font-bold text-blue-950">{n.name}</p>
              <p className="text-sm text-blue-900/80 font-semibold">{n.slogan}</p>
            </div>
            <button
              type="button"
              onClick={() => onPick(n)}
              className="shrink-0 bg-blue-600 hover:bg-blue-700 text-white rounded-full px-3 py-2 text-sm font-bold inline-flex items-center gap-1"
              data-testid={`biz-pick-${i}`}
            >
              <Heart className="w-4 h-4" /> {tx.pick}
            </button>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
